/* @flow */

import jQuery from 'jquery';

export type ConteudoModal = {
    titulo: string,
    texto: string,
    rodape?: string,
    tamanho?: 'lg' | 'md' | 'sm',
};

const modalVisualizacao = (valores: ConteudoModal) => {
    const $ = global.$ || jQuery;
    const $container: any = $('#modal-padrao');
    $('#modal-padrao-title').text(valores.titulo);
    $('#modal-padrao-body').html(valores.texto);
    $('#modal-padrao-footer').html(valores.rodape ? valores.rodape : '');
    if (valores.rodape) {
        $('#modal-padrao-footer').show();
    } else {
        $('#modal-padrao-footer').hide();
    }
    if (valores.tamanho) {
        const className = `modal-${valores.tamanho}`;
        $('#modal-padrao .modal-dialog')
            .removeClass('modal-lg')
            .removeClass('modal-sm')
            .removeClass('modal-md')
            .addClass(className);
    }
    $container.modal('show');
};

export default modalVisualizacao;
